import React, { Component } from "react";
import PropTypes from "prop-types";
import WizardFormOnePage from "./WizardFormOnePage";
import WizardFormSecondPage from "./WizardFormSecondPage";

class WizardPublish extends Component {
  constructor(props) {
    super(props);
    this.nextPage = this.nextPage.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.state = {
      page: 1
    };
  }
  nextPage() {
    this.setState({ page: this.state.page + 1 });
  }

  previousPage() {
    this.setState({ page: this.state.page - 1 });
  }

  render() {
    const { onSubmit } = this.props;
    const { page } = this.state;
    return (
      <div>
        {page === 1 && <WizardFormOnePage onSubmit={this.nextPage} />}
        {page === 2 && (
          <WizardFormSecondPage
          checkData={this.props.checkData}
          onClose={this.props.onClose}
            previousPage={this.previousPage}
            onSubmit={onSubmit}
          />
        )}
      </div>
    );
  }
}

WizardPublish.propTypes = {
  onSubmit: PropTypes.func.isRequired
};

export default WizardPublish;
